import { useCallback, useEffect, useState } from "react";

const KEY = "fmo_currency";
const EVENT = "fmo-currency";

const detect = () => {
  const lang = (navigator.languages?.[0] || navigator.language || "").toLowerCase();
  return lang.endsWith("-us") ? "usd" : "eur";
};

export const getCurrency = () => {
  const saved = localStorage.getItem(KEY);
  return saved === "usd" || saved === "eur" ? saved : detect();
};

// Selected display/checkout currency, shared by every toggle on the page (default: en-US → USD, otherwise EUR).
export const useCurrency = () => {
  const [cur, setState] = useState(getCurrency);
  useEffect(() => {
    const sync = () => setState(getCurrency());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  const set = useCallback((c) => {
    localStorage.setItem(KEY, c);
    window.dispatchEvent(new Event(EVENT));
  }, []);
  return [cur, set];
};
